import type { Caching } from "@/lib/caching"
import { isArray } from "@/lib/validation/isArray"
import { isNumericString } from "@/lib/validation/isNumericString"
import { isString } from "@/lib/validation/isString"

const isValidKeyType = (key: unknown, keys: unknown[]): key is Caching.Key => {
  const valid = isString(key) && !isNumericString(key)

  if (!valid) {
    console.warn(
      `cacheKeysValid failed: every key must be a non-numeric string.`,
      {
        key,
        keys,
      }
    )
  }

  return valid
}

const keysValidForStore = <Store extends Caching.BaseStore>(
  keys: unknown[],
  store: Store
) => {
  if (
    !keys.every((key) => {
      return isValidKeyType(key, keys)
    })
  ) {
    return false
  }

  if (!keys[0] || Object.hasOwn(keys, keys[0] as Caching.Key)) {
    console.warn(
      `cacheKeysValid failed: root key must already exist on the store.`,
      {
        key: keys[0],
        keys,
        store,
      }
    )
  }

  return true
}

export const cacheKeysValid = <Store extends Caching.BaseStore>(
  subject: unknown,
  store: Store
): subject is Caching.Keys<Store> => {
  if (isArray(subject)) {
    return keysValidForStore(subject, store)
  }

  return false
}
